var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { resolveTestId } from '@cvent/nucleus-test-automation';
/**
# CircleCounter Component
**/
var CircleCounter = function (props) {
    var label = props.label, digit = props.digit, type = props.type, total = props.total, fillingAnimationStartAt = props.fillingAnimationStartAt;
    var degree;
    if (fillingAnimationStartAt && fillingAnimationStartAt > total) {
        degree = 0;
    }
    else {
        var counterDigit = digit;
        while (counterDigit > total) {
            counterDigit = counterDigit - total; // Mostly used for days; prevent counter from looking wrong
        }
        degree = 360 - Math.floor(counterDigit / total * 360);
    }
    var rotation = 'rotate(' + degree + 'deg)';
    var halfRotation = 'rotate(' + degree / 2 + 'deg)';
    var spinnerStyle = {
        WebkitTransform: rotation,
        MozTransform: rotation,
        msTransform: rotation,
        Otransform: rotation,
        transform: rotation
    };
    var fillerStyle = {
        WebkitTransform: halfRotation,
        MozTransform: halfRotation,
        msTransform: halfRotation,
        Otransform: halfRotation,
        transform: halfRotation
    };
    var maskCss = resolve(props, 'mask');
    var fillerCss = resolve(props, 'border', type + 'Filler');
    var spinnerCss = resolve(props, 'border', type + 'Spinner');
    return React.createElement("li", __assign({}, resolveTestId(props), resolve(props, 'counter')),
        React.createElement("div", __assign({}, resolve(props, 'wrapper')),
            React.createElement("div", __assign({}, resolve(props, 'circle')),
                React.createElement("div", __assign({}, maskCss, { style: Object.assign({}, maskCss.style, fillerStyle) }),
                    React.createElement("div", __assign({}, fillerCss, { style: Object.assign({}, fillerCss.style, fillerStyle) }))),
                React.createElement("div", __assign({}, maskCss),
                    React.createElement("div", __assign({}, fillerCss, { style: Object.assign({}, fillerCss.style, fillerStyle) })),
                    React.createElement("div", __assign({}, spinnerCss, { style: Object.assign({}, spinnerCss.style, spinnerStyle) }))),
                React.createElement("div", __assign({}, resolve(props, 'digit', type + 'Digit')),
                    React.createElement("span", null, digit)))),
        React.createElement("span", __assign({}, resolve(props, 'label')), label));
};
CircleCounter.displayName = 'CircleCounter';
CircleCounter.propTypes = {
    /** Label text for the counter. */
    label: PropTypes.string,
    /** The actual value to display in the counter. */
    digit: PropTypes.number.isRequired,
    /** The unit of measurement for the counter. */
    type: PropTypes.oneOf(['days', 'hours', 'minutes', 'seconds']).isRequired,
    /** The max number of the unit of measurement. */
    total: PropTypes.number.isRequired,
    /** optional; sets the value of when animation starts; if omitted, defaults to the total value */
    fillingAnimationStartAt: PropTypes.number,
    /** Available Style Keys. */
    style: PropTypes.shape({
        /** Mask styles */
        mask: PropTypes.object,
        /** Top level style applied to the container. */
        counter: PropTypes.object,
        /** Style applied to the wrapper around circle part of the counter. */
        wrapper: PropTypes.object,
        /** Style applied to the circle part of the counter. */
        circle: PropTypes.object,
        /** Style applied to the label part of the counter. */
        label: PropTypes.object,
        /** Style for days filler. */
        daysFiller: PropTypes.object,
        /** Style for hours filler. */
        hoursFiller: PropTypes.object,
        /** Style for minutes filler. */
        minutesFiller: PropTypes.object,
        /** Style for seconds filler. */
        secondsFiller: PropTypes.object,
        /** Style for days spinner. */
        daysSpinner: PropTypes.object,
        /** Style for hours spinner. */
        hoursSpinner: PropTypes.object,
        /** Style for minutes spinner. */
        minutesSpinner: PropTypes.object,
        /** Style for seconds spinner. */
        secondsSpinner: PropTypes.object,
        /** Style for days digit. */
        daysDigit: PropTypes.object,
        /** Style for housr digit. */
        hoursDigit: PropTypes.object,
        /** Style for minutes digit. */
        minutesDigit: PropTypes.object,
        /** Style for seconds digit. */
        secondsDigit: PropTypes.object
    })
};
export default CircleCounter;
